import { GhostButton } from '@hobs/components/Buttons';
import Confirm from '@hobs/components/Confirm';
import Icon from '@hobs/components/Icon';
import Indicator from '@hobs/components/Indicator';
import Toast from '@hobs/components/Toast';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Styles from './withUnitDeletion.module.scss';


function withUnitDeletion(Component) {
    class UnitDeletion extends PureComponent {

        flattenUnits = (units) => {
            if (units.length > 0)
                return [...units, ...this.flattenUnits(units.map(x => x.units).flat())]
            return [...units];
        }

        onRemove = (unitId, markUnitPendingForDeletion, deleteUnit, onSuccess) => {
            const flatUnits = this.flattenUnits(this.props.partyUnits);
            const unit = flatUnits.find(x => x.unitId === unitId);

            if (unit.isAssignedToActiveSnSor) {
                Confirm(
                    this.props.t('Delete unit (Pending for deletion)'),
                    'This unit is currently active in an exercise. If you continue, the unit will be marked as pending for deletion and will be deleted once the exercise is finished. While marked for deletion, this unit will no longer be available in new exercises.',
                    () => {
                        const { t } = this.props;
                        const { partyId } = this.props.match.params;
                        markUnitPendingForDeletion().then(response => {
                            if (response.success) {
                                Toast.success(t('Unit is pending deletion'));
                                onSuccess();
                            } else {
                                Toast.warning(response.payload.message);
                            }
                        });
                    },
                    undefined,
                    this.props.t('Continue'),
                    this.props.t('Cancel')
                );
                return;
            }

            Confirm(
                this.props.t('Delete unit'),
                this.props.t('Are you sure you want to delete this unit?'),
                () => {
                    const { t } = this.props;
                    const { partyId } = this.props.match.params;
                    deleteUnit().then(response => {
                        if (response.success) {
                            Toast.success(t('Unit deleted successfully'));
                            onSuccess();
                        } else {
                            Toast.warning(response.payload.message);
                        }
                    });
                }
            );
        }

        renderCancelPendingDeletionButton = (unit, markUnitPendingForDeletion, onSuccess) => {
            return (
                <GhostButton
                    iconLeft={<Icon icon="delete" />}
                    onClick={() => {
                        markUnitPendingForDeletion().then(response => {
                            if (response.success) {
                                Toast.success(this.props.t('Unit is deletion cancelled'));
                                onSuccess()
                            } else {
                                Toast.warning(response.payload.message);
                            }
                        });
                    }}
                >
                    {this.props.t('Cancel')}
                </GhostButton>
            )
        }

        renderPendingDeletionUnitLabel = (unit) => {
            return (
                <div className={Styles["unit-indicator"]}>
                    <span>{unit.title}</span>
                    <Indicator
                        isGreen={!unit.isAssignedToActiveSnSor}
                        message={
                            unit.isAssignedToActiveSnSor ?
                                <div>
                                    Deletion pending. <br />
                                    Unit is currently assigned in an active SOR. <br />
                                    Deletion will be possible once SOR is finished. <br />
                                    While deletion is pending this unit is not visible in new SORs.
                                </div> :
                                <div>
                                    Deletion pending. <br />
                                    Unit is assigned to finished SOR and can be deleted.
                                </div>
                        } />
                </div>
            )
        }

        render() {
            return (
                <Component
                    onRemove={this.onRemove}
                    renderCancelPendingDeletionButton={this.renderCancelPendingDeletionButton}
                    renderPendingDeletionUnitLabel={this.renderPendingDeletionUnitLabel}
                    {...this.props}
                />
            );
        }
    }

    UnitDeletion.propTypes = {
        partyUnits: PropTypes.array,
        match: PropTypes.object,
        t: PropTypes.func,
    };

    const mapStateToProps = state => ({
        partyUnits: state.parties.partyUnits
    });

    return connect(
        mapStateToProps,
        null
    )(UnitDeletion);
}

export default withUnitDeletion;